import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { StatoAttoEnum } from "@app/shared/enum/stato-atto-enum";
import { TipologiaDecretoEnum } from "@app/shared/enum/tipologia-decreto-enum";
import { AttoWrapperVO } from "@app/shared/vo/attoWrapperVO";
import { ContatoreAttiVO } from "@app/shared/vo/contatore-attiVO";
import { FiltroRicercaAttoVO } from "@app/shared/vo/filtro-ricerca-attoVO";
import { FiltroRicercaAttoStore } from "@app/store/filtro-ricerca-atto-store";
import { isNullOrUndefined } from "util";

type itemContatoreAttiComponent = {
	label: string,
	icon: string,
	tipologia?: TipologiaDecretoEnum[],
	vistaSeduta?: boolean,
	filtroStatoAtto?: StatoAttoEnum | StatoAttoEnum[];
};
type itemKeyValueContatoreAttiComponent = { key: string, value: itemContatoreAttiComponent; };
@Component({
	selector: "app-contatore-atti",
	templateUrl: "./contatore-atti.component.html"
})
export class ContatoreAttiComponent {
	@Input() data: ContatoreAttiVO;
	@Input() set atti(atti: AttoWrapperVO[]) {
		const c: ContatoreAttiVO = new ContatoreAttiVO();
		if (atti) {
			Object.keys(this.mappa).forEach((keyFiltro: string) => {
				c[keyFiltro] = 0;
				const stati: StatoAttoEnum[] = <StatoAttoEnum[]>(Array.isArray(this.mappa[keyFiltro].filtroStatoAtto) ?
					this.mappa[keyFiltro].filtroStatoAtto :
					[this.mappa[keyFiltro].filtroStatoAtto]);
				atti.forEach((atto: AttoWrapperVO) => {
					if (stati.includes(atto.stato)) {
						c[keyFiltro]++;
					}
				});
			});
		}
		this.data = c;
	};
	@Input("zero-visible") zeroVisible: boolean = false;
	@Input("redirect") redirectEnable: boolean = false;
	@Input("tipologia") tipologia: TipologiaDecretoEnum;
	@Input("seduta") isSeduta: boolean = false;

	constructor(
		private filtroRicercaAttoStore: FiltroRicercaAttoStore,
		private router: Router,
	) {

	}

	isVisibleGroup(group: string[]): boolean {
		return group.some(((itemKey: string) => {
			return this.isVisibleItem(itemKey);
		}));
	}
	isVisibleItem(itemKey: string): boolean {
		const item: itemContatoreAttiComponent = this.mappa[itemKey];
		const value: number = this.data[itemKey] ? this.data[itemKey] : 0;
		return item &&
			(this.zeroVisible || value > 0) &&
			(
				isNullOrUndefined(item.tipologia) || 
				(!isNullOrUndefined(this.tipologia) && item.tipologia.includes(this.tipologia))
			) &&
			(!this.isSeduta || item.vistaSeduta);
	}

	redirectToListaAtti(item: itemKeyValueContatoreAttiComponent): void {
		if (!this.redirectEnable) return;
		const filtroRicercaAtto: FiltroRicercaAttoVO = new FiltroRicercaAttoVO();
		filtroRicercaAtto.stato = item.value.filtroStatoAtto;
		if (this.tipologia) {
			filtroRicercaAtto.tipologiaDecreto = this.tipologia;
		}
		//filtroRicercaAtto.tipologiaDecreto = !this.isNonContabile;
		filtroRicercaAtto.pageNumber = 0;
		filtroRicercaAtto.direz = "desc";
		filtroRicercaAtto.sort = "dataApertura";
		this.filtroRicercaAttoStore.setFiltroRicercaAtto(filtroRicercaAtto);
		this.router.navigate(["/gestione-atti/lista-atti"]);
	}

	ordinamentoMappa: string[][] = [

		["attiBozzaRevisione"],	//redattore
		["attiVerifica", "attiOsservati", "attiRifiutoContabile"], //verificatore
		["attiVerificaContabile"],
		["attiVistoContabile"],
		["attiApprovati", "attiApprovatiNotificare", "attiApprovatiCollegio"],
		["attiInFirma"],
		["attiFirmati"],
		["attiPubblicati"],
		["attiAnnullati", "attiRitirati"]
	];
	mappa: { [key: string]: itemContatoreAttiComponent; } = {
		attiRitirati: {
			vistaSeduta: false,
			label: "Ritirati",
			icon: "assignment_ind", //done(bozza),assignment_ind(da_revisionare)
			filtroStatoAtto: [StatoAttoEnum.RITIRATO]
		},
		attiBozzaRevisione: {
			vistaSeduta: false,
			label: "Bozza / Da revisione",
			icon: "edit", //done(bozza),assignment_ind(da_revisionare)
			filtroStatoAtto: [StatoAttoEnum.BOZZA, StatoAttoEnum.DA_REVISIONARE]
		},
		attiVerifica: {
			vistaSeduta: false,
			label: "Verifica",
			icon: "assignment_ind",
			filtroStatoAtto: StatoAttoEnum.VERIFICA
		},
		attiApprovati: {
			vistaSeduta: false,
			label: "Approvato",
			icon: "gavel",
			filtroStatoAtto: StatoAttoEnum.APPROVATO
		},
		attiInFirma: {
			vistaSeduta: true,
			label: "In firma",
			icon: "hourglass_full",
			filtroStatoAtto: StatoAttoEnum.IN_FIRMA
		},
		attiFirmati: {
			vistaSeduta: true,
			label: "Firmato",
			icon: "assignment_turned_in",
			filtroStatoAtto: StatoAttoEnum.FIRMATO
		},
		attiPubblicati: {
			vistaSeduta: true,
			label: "Pubblicato",
			icon: "done_all",
			filtroStatoAtto: StatoAttoEnum.PUBBLICATO
		},
		attiAnnullati: {
			vistaSeduta: true,
			label: "Annullati",
			icon: "assignment_ind",
			filtroStatoAtto: StatoAttoEnum.ANNULLATO
		},
		attiVerificaContabile: {
			tipologia: [TipologiaDecretoEnum.DECRETO_CONTABILE, TipologiaDecretoEnum.DECRETO_PROGRAMMAZIONE],
			vistaSeduta: false,
			label: "Verifica contabile",
			icon: "assignment_ind",
			filtroStatoAtto: StatoAttoEnum.VERIFICA_CONTABILE
		},
		attiVistoContabile: {
			tipologia: [TipologiaDecretoEnum.DECRETO_CONTABILE, TipologiaDecretoEnum.DECRETO_PROGRAMMAZIONE],
			vistaSeduta: true,
			label: "Visto contabile",
			icon: "assignment_ind",
			filtroStatoAtto: StatoAttoEnum.VISTO_CONTABILE
		},
		attiRifiutoContabile: {
			tipologia: [TipologiaDecretoEnum.DECRETO_CONTABILE, TipologiaDecretoEnum.DECRETO_PROGRAMMAZIONE],
			vistaSeduta: false,
			label: "Rifiuto contabile",
			icon: "assignment_ind",
			filtroStatoAtto: StatoAttoEnum.RIFIUTO_CONTABILE
		},
		attiApprovatiCollegio: {
			tipologia: [TipologiaDecretoEnum.DECRETO_CONTABILE, TipologiaDecretoEnum.DECRETO_PROGRAMMAZIONE],
			vistaSeduta: true,
			label: "Approvazione Collegio",
			icon: "hourglass_full",
			filtroStatoAtto: StatoAttoEnum.APPROVAZIONE_COLLEGIO
		},
		attiOsservati: {
			tipologia: [TipologiaDecretoEnum.DECRETO_CONTABILE, TipologiaDecretoEnum.DECRETO_PROGRAMMAZIONE],
			vistaSeduta: true,
			label: "Decreto osservato",
			icon: "assignment_ind",
			filtroStatoAtto: StatoAttoEnum.ATTO_OSSERVATO
		},
		attiApprovatiNotificare: {
			tipologia: [TipologiaDecretoEnum.DECRETO_CONTABILE, TipologiaDecretoEnum.DECRETO_PROGRAMMAZIONE],
			vistaSeduta: true,
			label: "Approvato da notificare",
			icon: "assignment_ind",
			filtroStatoAtto: StatoAttoEnum.APPROVATO_DA_NOTIFICARE
		},
	};
}
